// projects.ts — Patch 010.A.4 R7 split. Project list/create/delete.

import { request } from './request'
import type {
  AdvanceProjectPhaseInput,
  AdvanceProjectPhaseResponse,
  CreateProjectInput,
  CreateProjectResponse,
  ProjectListEntry,
} from './types'

export const projectsApi = {
  list: () =>
    request<{ ok: true; projects: ProjectListEntry[] }>('/api/projects'),
  create: (body: CreateProjectInput) =>
    request<CreateProjectResponse>('/api/projects', {
      method: 'POST',
      body: JSON.stringify(body),
    }),
  // MCC<->HCC handoff (F53): convert a lead/prospect/former_client profile into
  // a project (the profile becomes the client; relationship + primary_profile_id
  // wired atomically). Returns the new project id.
  fromProfile: (body: {
    profile_id: string
    address: string
    city: string
    state: string
    zip: string
    name?: string
    current_phase?: string
    secondary_profile_id?: string
    allow_concurrent_active_project?: boolean
  }) =>
    request<{
      ok: true
      project: { id: string; display_name: string; status: string }
      client_id: string
      relationship_ids: string[]
      profile_id: string
      request_id: string
    }>('/api/projects/from-profile', {
      method: 'POST',
      body: JSON.stringify(body),
    }),
  // Patch 010.0.4 — soft-delete a project. Two-stage UX in DeleteProjectModal
  // gates the actual call (warning → type-to-confirm address → red Delete).
  delete: (projectId: string) =>
    request<{ ok: true; deleted_at: string; request_id: string }>(
      `/api/projects/${encodeURIComponent(projectId)}`,
      { method: 'DELETE' },
    ),
  // Chassis CH-2 — phase-advance (operator lifecycle).
  advancePhase: (projectId: string, body: AdvanceProjectPhaseInput) =>
    request<AdvanceProjectPhaseResponse>(
      `/api/projects/${encodeURIComponent(projectId)}`,
      {
        method: 'PATCH',
        body: JSON.stringify(body),
      },
    ),
}
